<template>
    <div class="flex flex-col transform transition-transform duration-200 origin-top">
        <router-link v-if="urlContainsString && link != '/'" id="launchpadButton" :to="link" class="flex items-center hover:bg-gray-100 py-3 cursor-pointer h-12 pl-4">
            <LucideIcon :name="icon" :size="22" :stroke-width="1.8" color="#302E81" class="self-center" />
            <p class="text-[15px] pt-[3px] text-[#302E81] font-medium w-auto pl-3 whitespace-wrap self-center">{{ text }}</p>
        </router-link>
        <router-link v-else id="launchpadButton" :to="link" class="flex items-center hover:bg-gray-100 py-3 cursor-pointer h-12 pl-4">
            <LucideIcon :name="icon" :size="22" :stroke-width="1.8" color="#20283A" class="self-center" />
            <p class="text-[15px] pt-[3px] text-gray-800 font-medium w-auto pl-3 whitespace-wrap self-center">{{ text }}</p>
        </router-link>
    </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import LucideIcon from "@/components/LucideIcon.vue";

export default {
    name: "LaunchpadButton",
    props: {
        text: {
            type: String,
            required: true
        },
        link: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: true
        }
    },
    components: {
        LucideIcon
    },
    setup(props) {
        const route = useRoute();
        const urlContainsString = ref(false);

        const checkURL = () => {
            // Access props.link inside this function to avoid the error
            urlContainsString.value = route.fullPath.includes(props.link);
        };

        // Check URL on component mount
        onMounted(() => {
            checkURL();
        });

        // Watch for changes in the route to re-evaluate the URL
        watch(route, () => {
            checkURL();
        });

        return {
            urlContainsString
        };
    }
};
</script>

<style scoped>
</style>